
import Vue from "vue";
import AppReportSendModal from "@/components/reportengine/ReportSendModal.vue";
import AppPdfViewer from "@/components/common/PdfViewer.vue";
import { AWSFileService } from "../../services/aws-file-service";
import {PdfImages} from "@/utils/pdf-images";

export default Vue.extend({
	data() {
		return {
			openSendModal: false,
			openPreview: false,
			attachment: [] as [] | File,
			blob: null as null | Blob,
			images: null as null | PdfImages,
			isPrinting: false,
			isPreparingPreview: false,
			isPreparingSendModal: false
		};
	},
	props: {
		value: {
			type: Object as () =>{url:string, fileName:string},
			required: true
		}
	},
	computed: {
		canPrint():boolean{
			if (!this.value.fileName) return false;
			return !this.value.fileName.includes("xls");
		}
	},
	methods: {
		async download() {
			await AWSFileService.downloadFile(this.value.url, this.value.fileName);
		},
		async print() {
			try{
				console.log("Printing");
				this.isPrinting = true;
				await AWSFileService.printFile(this.value.url, this.value.fileName);
			}catch(err){
			}finally{
				console.log("Done printing");
				this.isPrinting = false;
			}
		},
		async preview() {
			try{
				this.isPreparingPreview = true;
				let a =  await AWSFileService.fetchFile(this.value.url, this.value.fileName, "");
				this.blob = a;
				this.openPreview = true;
			}catch(err){
			}finally{
				this.isPreparingPreview = false;
			}
		},
		async send() {
			try{
				this.isPreparingSendModal = true;
				let a =  await AWSFileService.fetchFile(this.value.url, this.value.fileName, "");
				this.attachment = new File([a],this.value.fileName, {type: a.type});
				this.openSendModal = true;
			}catch(err){
			}finally{
				this.isPreparingSendModal = false;
			}
		},
		close() {
			this.$emit("close");
		},
	},
	components: {
		AppReportSendModal,
		AppPdfViewer
	},
	i18nEx: {
		componentPrefix: "components.reportengine"
	}
});
